import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { PageTitle, PageContent } from 'nallian-shared-ui/lib/components';
import { getFilters } from 'nallian-shared-ui/lib/hoc/redux-filters';
import { getSorting } from 'nallian-shared-ui/lib/hoc/redux-sorting';
import { withTranslation } from 'react-i18next';
import NewAccessRightModal from './NewAccessRightModal';
import EditAccessRightModal from './EditAccessRightModal';
import accessRightService from '../services/accessRightService';
import deleteAccessRightService from '../services/deleteAccessRightService';
import VehicleSidebar from '../../vehicleSidebar/components/VehicleSidebar';
import AccessRightsDownloadCsvButton from './AccessRightsDownloadCsvButton';
import AccessRightsOverviewTable from './AccessRightsOverviewTable';

export const ACCESS_RIGHTS_ACTIONS = {
  EDIT: 'edit',
  NEW: 'new',
  VEHICLE_DETAILS: 'details',
};

class AllAccessRightsOverview extends PureComponent {
  state = {
    accessRightsLoading: [],
  };

  componentDidMount() {
    if (this.props.dispatchAccessRightsGet) {
      this.props.dispatchAccessRightsGet(this.props.filters, this.props.sorting);
    }
  }

  handleDeleteAccessRight = accessRightId => {
    this.setState(prevState => ({
      accessRightsLoading: [...prevState.accessRightsLoading, accessRightId],
    }));
    this.props.dispatchDeleteAccessRightDelete(accessRightId, () =>
      this.setState(prevState => ({
        accessRightsLoading: prevState.accessRightsLoading.filter(
          loadingId => accessRightId !== loadingId
        ),
      }))
    );
  };

  render() {
    const { match, t } = this.props;
    const { action, actionId, subAction, subActionId } = match.params;
    return (
      <>
        <NewAccessRightModal open={!!action && action === ACCESS_RIGHTS_ACTIONS.NEW} />
        <EditAccessRightModal
          accessRightId={
            ((action && action === ACCESS_RIGHTS_ACTIONS.EDIT) || undefined) && actionId
          }
        />
        <VehicleSidebar
          vehicleId={
            ((action && action === ACCESS_RIGHTS_ACTIONS.VEHICLE_DETAILS) || undefined) && actionId
          }
          baseUrl="/all-accessrights"
          sidebarAction={subAction}
          sidebarActionId={subActionId}
          sidebarUrl={`/all-accessrights/${ACCESS_RIGHTS_ACTIONS.VEHICLE_DETAILS}/${actionId}`}
        />

        <PageTitle>{t('allAccessRights')}</PageTitle>
        <PageContent>
          <AccessRightsDownloadCsvButton />
          <AccessRightsOverviewTable baseUrl="/all-accessrights" />
        </PageContent>
      </>
    );
  }
}

AllAccessRightsOverview.propTypes = {
  t: PropTypes.func.isRequired,
  accessRightsFetch: PropTypes.object.isRequired,
  dispatchDeleteAccessRightDelete: PropTypes.func.isRequired,
  dispatchAccessRightsGet: PropTypes.func.isRequired,
  accessRightsPageFetch: PropTypes.object.isRequired,
  dispatchAccessRightsPageGet: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  filters: PropTypes.object,
  sorting: PropTypes.object,
};

AllAccessRightsOverview.defaultProps = {
  filters: undefined,
  sorting: undefined,
};

const mapStateToProps = state => ({
  filters: getFilters(state, 'AllAccessRightsOverviewFilters'),
  sorting: getSorting(state, 'AllAccessRightsOverviewSorting'),
});

export default compose(
  withTranslation(),
  deleteAccessRightService,
  accessRightService,
  connect(mapStateToProps)
)(AllAccessRightsOverview);
